import React from 'react'
import Modal from 'react-responsive-modal'

export default function WrappedModal ({children, classNames = {}, ...props}) {
  let modalClassNames = 'modal-container'
  if (classNames && classNames.modal) {
    modalClassNames = `${modalClassNames} ${classNames.modal}`
  }

  Object.assign(classNames, { modal: modalClassNames })

  return (
    <Modal {...props} classNames={classNames}>
      {children}
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./assets/js/components/modal/Modal.jsx